module.exports = __webpack_public_path__ + "img/A58A0834_min.db622c64.jpg";